export const AI_CHAT_NAVIGATION_INTENTS = [
	"view_menu",
	"view_loyalty_program",
	"leave_a_tip",
];

export const AI_CHAT_BUTTON_ACTION_INTENTS = [
	"finalize_order",
	...AI_CHAT_NAVIGATION_INTENTS,
];

export function getAiChatNavigationIntents(intents = []) {
	if (!Array.isArray(intents)) return [];
	return AI_CHAT_NAVIGATION_INTENTS.filter((intent) => intents.includes(intent));
}

export function getAiChatButtonActionIntents(intents = []) {
	if (!Array.isArray(intents)) return [];
	return AI_CHAT_BUTTON_ACTION_INTENTS.filter((intent) => intents.includes(intent));
}

function closeAfterNavigation({
	anyModalOpen = false,
	closeAllModals = false,
} = {}) {
	if (closeAllModals || anyModalOpen) {
		window.store?.emit("close_all_modals");
		if (anyModalOpen && !closeAllModals) return;
	}

	window.store?.emit("close_chat");
}

export function handleAiChatAction(action, options = {}) {
	const actionName = String(action || "").trim();
	if (!actionName) return false;

	if (actionName === "finalize_order") {
		if (options.anyModalOpen || options.closeAllModals) {
			window.store?.emit("close_all_modals");
			if (options.anyModalOpen && !options.closeAllModals) return true;
		}

		window.store?.emit("close_chat");
		window.__cng_common?.order_confirm_modal?.open?.();
		return true;
	}

	if (actionName === "leave_a_tip") {
		const tipsNavigation = document.querySelector('[data-feature="tips_direct"]');
		if (tipsNavigation) tipsNavigation.click();
		if (options.closeAfterNavigation !== false) closeAfterNavigation(options);
		return true;
	}

	if (actionName === "call_the_waiter") {
		window.__cng_common?.call_the_waiter?.();
		return true;
	}

	if (actionName === "view_menu") {
		const menuNavigation = document.querySelector('[data-feature="menu"]');
		if (menuNavigation) menuNavigation.click();
		if (options.closeAfterNavigation !== false) closeAfterNavigation(options);
		return true;
	}

	if (actionName === "view_loyalty_program") {
		const loyaltyNavigation = document.getElementById("cng_drawer_my_loyalty_points");
		if (loyaltyNavigation) loyaltyNavigation.click();
		if (options.closeAfterNavigation !== false) closeAfterNavigation(options);
		return true;
	}

	return false;
}
